// extracted by mini-css-extract-plugin
export var aboveInput = "_nd-0";
export var actionButton = "_nd-5";
export var actionButtonContainer = "_nd-1";
export var actionIcon = "_nd-6";
export var aiInfoContainer = "_nd-2";
export var attachmentWrapper = "_nd-7";
export var bold = "_nd-3";
export var checkIcon = "_nd-8";
export var clickingRecipientBar = "_nd-11";
export var commentThreadSwitch = "_nd-a";
export var draftImage = "_nd-b";
export var draftImageContainer = "_nd-c";
export var draftImages = "_nd-e";
export var editButton = "_nd-g";
export var editor = "_nd-f";
export var editorContainer = "_nd-y";
export var editorErrorTooltipWrapper = "_nd-9";
export var headerDivider = "_nd-h";
export var icon = "_nd-i";
export var info = "_nd-j";
export var internal = "_nd-n";
export var internalDivider = "_nd-k";
export var internalMessage = "_nd-l";
export var messageInputCard = "_nd-m";
export var messageInputForm = "_nd-o";
export var messageInputFormInternal = "_nd-p";
export var options = "_nd-q";
export var publicMessageCustomer = "_nd-s";
export var publicMessageMerchant = "_nd-r";
export var removeImageButton = "_nd-d";
export var replyButtons = "_nd-t";
export var showSignatureButton = "_nd-u";
export var spinner = "_nd-v";
export var verticalButtonDivider = "_nd-4";
export var visibilitySelector = "_nd-w";
export var warning = "_nd-x";
export var wrappingText = "_nd-z";
export var writingInternalNoteTopBorder = "_nd-10";